import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import generatePassword from 'password-generator';

export default class Sales extends Component {

  configure() {
    return super.configure();
  }

  initialize() {

    this.form = $('.is-sales-form');
    this.actionInput = this.form.find('input[name="action"]');
    this.submitButtons = this.form.find('button[type="submit"]');
    this.section = this.form.closest('.section');

    this.subscribeToEvents();
    return super.initialize();

  }

  subscribeToEvents() {

    this.App.Events.subscribe('sales.list.updated', (id) => {
      return this.onSalesListUpdated(id);
    });

    this.submitButtons.on('click', () => {
      this.actionInput.val($(this).attr('value'));
    });

  }

  onSalesListUpdated(id) {

    this.form.find('input[name^="content_id"]').remove();
    $.each(id, (i, value) => {
      this.form.prepend('<input type="hidden" name="content_id[]" value='+ value +' />');
    });

    if (id == null || id.length === 0) {
      this.section.addClass('is-hidden');
    } else {
      this.section.removeClass('is-hidden');
    }
  }

}